import {
    UPDATE_PHONE_NUMBER,
    UPDATE_USER_DATA,
    UPDATE_AU_SETTINGS,
    RESET_USER_INFO,
    UPDATE_TIME_ZONE,
    CREATE_USER_LICENSE,
    UPDATE_USER_LICENSE,
    DELETE_USER_LICENSE,
    GET_USER_INFO,
    GET_NOTIFICATION_SETTINGS,
    UPDATE_NOTIFICATION_SETTINGS
  } from "./actionConstants";

export const getManageUserList = payload => ({
    type: GET_USER_INFO,
    payload
});

export const updatePhoneNumber = payload =>({
  type: UPDATE_PHONE_NUMBER,
  payload
});

export const updateUserData = payload =>({
  type: UPDATE_USER_DATA,
  payload
});

export const updateAUSettings = payload => ({
  type: UPDATE_AU_SETTINGS,
  payload
})

export const getNotificationSettings = payload => ({
  type: GET_NOTIFICATION_SETTINGS,
  payload
})

export const updateNotificationSettings = payload => ({
  type: UPDATE_NOTIFICATION_SETTINGS,
  payload
})

export const resetUserInfo = payload => ({
  type:RESET_USER_INFO,
  payload
})

export const updateTimeZoneData = payload => ({
  type:UPDATE_TIME_ZONE,
  payload
})

export const createUserLicense = payload =>({
  type: CREATE_USER_LICENSE,
  payload
});

export const updateUserLicense = payload =>({
  type: UPDATE_USER_LICENSE,
  payload
});

export const deleteUserLicense = payload =>({
  type: DELETE_USER_LICENSE,
  payload
});